module.exports = __webpack_public_path__ + "img/off-button.557b20c2.png";